/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Reposition_To_TopInputs */



/**
* | output |
* | --- |
* | "Reposition to Top" |
*
* @param {Subtitle_Export_Reposition_To_TopInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_reposition_to_top = /** @type {((inputs?: Subtitle_Export_Reposition_To_TopInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Reposition_To_TopInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Repositionner en haut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neu positionieren an die Spitze")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riposiziona in alto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместить наверх")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reposicionar en la parte superior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("返回顶部")
	if (locale === "ja") return /** @type {LocalizedString} */ ("上部に再配置")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शीर्ष पर पुनः स्थान प्राप्त करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reposicionar para o topo")
	return /** @type {LocalizedString} */ ("Reposition to Top")
});